import lodash from 'lodash';

import type { LetterGradeRow } from 'bundles/authoring-grading-formula/types/LetterGradeRow';
import type {
  LetterGradeRules,
  LetterGradeScheme as LetterGradeSchemeType,
} from 'bundles/authoring-grading-formula/types/LetterGradeScheme';
import uuid from 'bundles/common/utils/uuid';

const DEFAULT_LETTER_GRADE_RULES: LetterGradeRules = {
  A: 0.9,
  B: 0.8,
  C: 0.7,
  D: 0.6,
  F: 0,
};

/**
 * Model for grading parameters
 */
export default class LetterGradeScheme {
  declare letterGradeScheme: LetterGradeSchemeType;

  constructor(letterGradeScheme: LetterGradeSchemeType = {}) {
    this.letterGradeScheme = letterGradeScheme;
  }

  get isLetterGradingEnabled(): boolean {
    return this.letterGradeScheme && !lodash.isEmpty(this.letterGradeScheme.letterGradeRules);
  }

  get defaultLetterGradeScheme(): LetterGradeSchemeType {
    return {
      letterGradeRules: DEFAULT_LETTER_GRADE_RULES,
    };
  }

  clone = () => {
    const { letterGradeScheme } = lodash.cloneDeep(this);

    return new LetterGradeScheme(letterGradeScheme);
  };

  clearLetterGradeScheme = () => {
    this.letterGradeScheme = {};
  };

  setDefaultLetterGradeScheme = () => {
    this.letterGradeScheme = this.defaultLetterGradeScheme;
  };

  getLetterGradeSchemeTableData = () => {
    if (!this.isLetterGradingEnabled || !this.letterGradeScheme.letterGradeRules) {
      return [];
    }

    const { letterGradeRules } = this.letterGradeScheme;

    const grades: Array<LetterGradeRow> = [];
    lodash.forEach(letterGradeRules, function (value, key) {
      const gradeRow = {
        gradeText: key,
        threshold: value as number,
        id: uuid(),
        errors: {
          duplicateGradeText: false,
          duplicateThreshold: false,
        },
      };
      grades.push(gradeRow);
    });
    return grades;
  };

  setLetterGradeSchemeFromTableData = (tableData: Array<LetterGradeRow>) => {
    const letterGradeRules = {};
    lodash.map(tableData, (row) => {
      const key = row.gradeText;
      const value = row.threshold;
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      letterGradeRules[key] = value;
    });

    this.letterGradeScheme.letterGradeRules = letterGradeRules;
  };

  toJSON() {
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#toJSON()_behavior
    return this.letterGradeScheme;
  }
}
